import React, { useEffect } from 'react';
import $ from 'jquery';
import { IProps } from './types';

const FunctionsItem00: React.FC<IProps> = (props) => {
  /**
   * @description 實作 hover 效果
   */
  useEffect(() => {
    const elem = $(`#${props.id}`);
    if (elem) {
      elem.on('mouseenter', addActiveClass);
      elem.on('mouseleave', removeActiveClass);
    }
    return () => {
      if (elem) {
        elem.off('mouseenter', addActiveClass);
        elem.off('mouseleave', removeActiveClass);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  /**
   * @description 針對目標元素增加 active 樣式類別
   */
  const addActiveClass = () => {
    const elem = $(`#${props.id}`);
    if (elem) elem.addClass('active');
  };

  /**
   * @description 針對目標元素移除 active 樣式類別
   */
  const removeActiveClass = () => {
    const elem = $(`#${props.id}`);
    if (elem) elem.removeClass('active');
  };

  return (
    <div id={props.id} className={'header__functions-item' + (props.isActive ? ' active' : '')}>
      {props.children}
    </div>
  );
};

export default FunctionsItem00;
